import { ActivePromoForCruise } from "src/utils/promos";
import { CruiseTemplateSuiteFragment } from "types/graphql-types";
import { match, P } from "ts-pattern";

const ray = "3db5dcaa-58ca-4c6b-8496-01a8a834c8e7";
const nova = "401eb801-8061-426a-baf5-e72d484a842b";
const endeavour = "5653ea42-6a9c-4f6a-90b3-020b2c5add8c";
const cloud = "ship-silver-cloud-expedition";
const dawn = "ship-silver-dawn";
const moon = "ship-silver-moon";
const muse = "ship-silver-muse";
const shadow = "ship-silver-shadow";
const spirit = "ship-silver-spirit";
const whisper = "ship-silver-whisper";
const wind = "ship-silver-wind";
const origin = "ship-silver-origin";

const isLowerSuite = (suite: CruiseTemplateSuiteFragment, shipId: string) => {
  const suiteCategoryOrder = suite?.category?.order || 0;

  return match(shipId)
    .with(P.union(wind, cloud, origin), () => suiteCategoryOrder > 30)
    .with(endeavour, () => suiteCategoryOrder > 29)
    .with(
      P.union(whisper, muse, shadow, spirit, moon, dawn),
      () => suiteCategoryOrder > 35
    )
    .with(P.union(nova, ray), () => suiteCategoryOrder > 30)
    .otherwise(() => suiteCategoryOrder > 25);
};

export const fakeSuiteUpgradePromo = (
  suite: CruiseTemplateSuiteFragment,
  activePromos: ActivePromoForCruise[],
  shipId: string
) => {
  const suiteUpgradesPromo = activePromos.find(
    (p) => p.code == "CATEGORY_UPGRADE"
  );
  const isTargetSuite = isLowerSuite(suite, shipId);

  if (suiteUpgradesPromo && isTargetSuite) {
    return suiteUpgradesPromo;
  }

  return undefined;
};
